module.exports = __webpack_public_path__ + "static/media/DouaneInstaller.6e13e293.png";